import Vue from 'vue';

export default {
  state: {
    user: null,
  },
  mutations: {
    SESSION_SET_USER (state, { user }) {
      state.user = user
    },
  },
  actions: {
    SESSION_CREATE ({ commit }, creds) {
      return Vue.http.post('session', creds).then((response) => {
        commit('SESSION_SET_USER', response.body)
      })
    },
    SESSION_DESTROY({ commit }) {
      return Vue.http.delete('session').then(() => {
        commit('SESSION_SET_USER', { user: null })
      })
    },
    SESSION_INIT ({ commit }) {
      return Vue.http.get('user/current').then((response) => {
        commit('SESSION_SET_USER', response.body)
      })
    },
    SESSION_UPDATE_USER ({ commit, state }, user) {
      const updatedUser = Object.assign({}, state.user, user)
      commit('SESSION_SET_USER', updatedUser)
      return Vue.http.put('user', updatedUser)
    }
  },
};
